<mat-card appearance="outlined" class="cur-card">
    <mat-card-header>
      <mat-card-title>請求基本情報</mat-card-title>
      <div>
        <mat-icon>contact_page</mat-icon>
      </div>
    </mat-card-header>
    <mat-card-content>

      <div class="flex flex-row flex-wrap box-border justify-start items-center content-center">
        <mat-form-field appearance="fill" class="input-form box-border grow shrink basis-full max-w-30% md:max-w-full">
          <mat-label>請求基本番号</mat-label>
          <input matInput id="recptFixNo" value="{{billingBasicInfo.recptFixNo}}" class="font-color-display-only"
            disabled />
        </mat-form-field>
        <mat-form-field appearance="fill" class="input-form box-border grow shrink basis-full max-w-30% md:max-w-full">
          <mat-label>請求先お客さま名（漢字）</mat-label>
          <input matInput id="visitName" value="{{billingBasicInfo.visitName}}" class="font-color-display-only"
            disabled />
        </mat-form-field>
      </div>

      <div class="flex flex-row flex-wrap box-border justify-start items-center content-center">
        <mat-form-field appearance="fill" class="input-form box-border grow shrink basis-full max-w-30% md:max-w-full">
          <mat-label>お客さま電話番号コード１</mat-label>
          <input matInput id="telNoDiv1Aname" value="{{billingBasicInfo.telNoDiv1Aname}}" class="font-color-display-only"
            disabled />
        </mat-form-field>
        <mat-form-field appearance="fill" class="input-form box-border grow shrink basis-full max-w-30% md:max-w-full">
          <mat-label>お客さま電話番号１</mat-label>
          <input matInput id="telNo1" value="{{billingBasicInfo.telNo1}}" class="font-color-display-only" disabled />
        </mat-form-field>
      </div>
      <div class="flex flex-row flex-wrap box-border justify-start items-center content-center">
        <mat-form-field appearance="fill" class="input-form box-border grow shrink basis-full max-w-90% md:max-w-full">
          <mat-label>住所</mat-label>
          <input matInput id="visitAddrInf" [value]="billingBasicInfo.visitAddrInfDto | billDispZyuusyo
                  " class="font-color-display-only" disabled />
        </mat-form-field>
      </div>
      <div class="flex flex-row flex-wrap box-border justify-start items-center content-center">
        <mat-form-field appearance="fill" class="input-form box-border grow shrink basis-full max-w-30% md:max-w-full">
          <mat-label>まとめ請求区分</mat-label>
          <input matInput id="mtmclmDivAname" value="{{billingBasicInfo.mtmclmDivAname}}" class="font-color-display-only"
            disabled />
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>
